import { defineAsyncComponent, App } from 'vue';

const NavigationTree = defineAsyncComponent(() => import('@/project/search/navigation/NavigationTree.vue'));

export default function navigationComponentRegistration(app: App): void {
    app.component('NavigationTree', NavigationTree);
}
